module.exports = __webpack_public_path__ + "media/images/favicon/ios-app-store-50cfdad191c7f25a7db6eab11f431dd2.png";